module.exports = __webpack_public_path__ + "img/favicon.3be889a.png";